import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Navigation from 'components/navigation';

const MainMenu = ({ data, result, step, setStep, setMenu, complete }) => {

  const [check, setCheck] = useState(null);
  const [next, setNext] = useState(false);
  const [done, setDone] = useState([]);

  //setStep(4);

  useEffect(() => {
    let temp = [];
    for (let key in result) {
      if (result[key].type === 'menu') {
        if (Object.keys(result[key]).length === 3) {
          temp.push(+key);
        }
      }
    }
    setDone(temp);
  }, []);

  const selectedMenu = id => {
    if (!done.includes(id + 1)) {
      setMenu(id);
      setCheck(id);
      setNext(true);
      setStep(step + 1);
      console.log('selectedMenu', id );
    }
  };

  // console.log('menu complete', complete);

  return (
    <div className="mainMenu-wrapper">
      <h1 className="titile-step">{data.mainMenu.title}</h1>
      {/*<h2 className="step-number">Step {step}</h2>*/}

      <Navigation
        step={step}
        setStep={setStep}
        next={next}
        answer={{ [check + 1]: {} }}
      />
     
      {data &&
        data.mainMenu.modules.map((item, index, arr) => (
          <div
            key={index}
            className={classnames('module-wrapper', {
              'menu-done': done.includes(index + 1),
            })}
            onClick={() => selectedMenu(index)}
          >
            <div className="module-text">
              <div className="module-title">
                {index + 1 + '. ' + item.title}
              </div>
              <div className="module-info">{item.info}</div>
            </div>
            <div className="module-img">
              <img src={item.img} alt="plan" />
            </div>
          </div>
        ))}

        {data && 
          <div
            key={data.mainMenu.modules.length}
            className={classnames( !complete ? 'module-wrapper unactive' : 'module-wrapper', {
              'menu-done': done.includes(data.mainMenu.modules.length + 1),
            })}
            onClick={() => selectedMenu(data.mainMenu.modules.length)}
          >
            <div className="module-text">
              <div className="module-title">
                {data.mainMenu.modules.length + 1 + '. ' + data.generalModule.title}
              </div>
              <div className="module-info">{data.generalModule.info}</div>
            </div>
            <div className="module-img">
              <img src={data.generalModule.img} alt="plan" />
            </div>
          </div>
        }



    </div>
  );
};

export default MainMenu;
